<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9982 2.05389C6.5066 2.05389 2.04785 6.51261 2.04785 12.0045C2.04785 17.4965 6.5066 21.9552 11.9982 21.9552C17.4897 21.9552 21.9484 17.4965 21.9484 12.0045C21.9484 6.51261 17.4897 2.05389 11.9982 2.05389ZM11.9982 3.63851C16.616 3.63851 20.3641 7.38724 20.3641 12.0045C20.3641 16.6218 16.616 20.3706 11.9982 20.3706C7.38133 20.3706 3.63214 16.6218 3.63214 12.0045C3.63214 7.38724 7.38133 3.63851 11.9982 3.63851ZM11.2055 6.87951V12.728C11.2055 12.9382 11.2896 13.1396 11.4377 13.2883L14.5453 16.3952C14.8546 16.7044 15.356 16.7044 15.6652 16.3952C15.9745 16.086 15.9745 15.5839 15.6652 15.2747L12.7908 12.3998V6.87951C12.7908 6.44215 12.4355 6.08715 11.9982 6.08715C11.5608 6.08715 11.2055 6.44215 11.2055 6.87951Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'StateWaiting'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
